import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-modal-container-value',
  template: `
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title flex-fill text-center" id="headerLabel">{{title}}</h2>
          <div *ngIf="dismissible || dismissible === undefined">
            <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(null)"></button>
          </div>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
      <div *ngIf="footer" class="modal-footer">
        <button type="button" class="{{linkButtonStyle}}" (click)="activeModal.close(null)">
          <span [innerHTML]="cancelText"></span>
        </button>
        <button type="button" [attr.ngbAutofocus]="autofocus" class="{{primaryButtonStyle}}" [disabled]="disabled"
          (click)="activeModal.close(value)">
          <span [innerHTML]="confirmText"></span>
        </button>
      </div>
    </div>
  `
})
export class ModalContainerValueComponent {

  @Input()
  title: string;

  @Input()
  labelCancel: string;

  @Input()
  labelConfirm: string;

  @Input()
  dismissible = true;

  @Input()
  extraCssPrimaryBtn = '';

  @Input()
  extraCssLinkBtn = '';

  @Input()
  footer = true;

  @Input()
  disabled = false;

  @Input()
  autofocus = true;

  @Input()
  public value: any;

  constructor(public activeModal: NgbActiveModal) { }

  get cancelText(): string {
    return this.labelCancel ? this.labelCancel : 'Cancel';
  }

  get confirmText(): string {
    return this.labelConfirm ? this.labelConfirm : 'Confirm';
  }

  get primaryButtonStyle(): string {
    let buttonStyle = this.extraCssPrimaryBtn ? this.extraCssPrimaryBtn : 'btn-primary';
    return 'btn ' + buttonStyle;
  }

  get linkButtonStyle(): string {
    let buttonStyle = this.extraCssLinkBtn ? this.extraCssLinkBtn : 'btn-link';
    return 'btn ' + buttonStyle;
  }
}
